import { getMocaEntryType, MocaEntryType } from './entry';

const ORG_TOKEN_KEY = 'mocaAppOrgToken';
const ORG_TOKEN_EXPIRES_KEY = 'mocaAppOrgTokenExpiresAt';
const ORG_USER_KEY = 'mocaOrgUserInfo';
const MAIN_TOKEN_KEY = 'mocaAppToken';
const REGISTERED = 'registered';

export const MocaOrgTokenIfo = {
  ORG_TOKEN_KEY: ORG_TOKEN_KEY,
  ORG_TOKEN_EXPIRES_KEY: ORG_TOKEN_EXPIRES_KEY,
  ORG_USER_KEY: ORG_USER_KEY,
  MAIN_TOKEN_KEY: MAIN_TOKEN_KEY,
  REGISTERED: REGISTERED
};


// 获取当前 MOCA 页面入口类型，统一作为主系统/机构分流判断的入口
export function getCurrentMocaEntryType() {
  return getMocaEntryType();
}

// 判断当前是否为机构入口；机构入口下走独立 token 与独立校验逻辑
export function isOrgEntry() {
  return getCurrentMocaEntryType() === MocaEntryType.ORG;
}

// 判断当前是否为主系统入口；主系统入口继续复用综合运营平台登录态
export function isMainEntry() {
  return getCurrentMocaEntryType() === MocaEntryType.MAIN;
}

// 保存机构登录态：包含 token、过期时间和机构用户信息
export function setOrgSession({ token, expiresAt, userInfo, registered } = {}) {
  if (token) uni.setStorageSync(ORG_TOKEN_KEY, token);
  if (expiresAt) uni.setStorageSync(ORG_TOKEN_EXPIRES_KEY, String(expiresAt));
  if (userInfo) uni.setStorageSync(ORG_USER_KEY, userInfo);
  if (registered) uni.setStorageSync(REGISTERED, registered);
}

// 读取机构 token，供请求拦截器自动注入 header 使用
export function getOrgToken() {
  return uni.getStorageSync(ORG_TOKEN_KEY) || '';
}

// 读取机构 token 的过期时间，返回时间戳；未设置时返回 0
export function getOrgTokenExpiresAt() {
  const value = uni.getStorageSync(ORG_TOKEN_EXPIRES_KEY);
  return value ? Number(value) : 0;
}

// 读取机构用户信息，用于首页头像、机构用户详情页展示
export function getOrgUserInfo() {
  return uni.getStorageSync(ORG_USER_KEY) || null;
}

// 判断机构 token 是否已过期；过期后应重新进入机构登录页
export function isOrgTokenExpired() {
  const expiresAt = getOrgTokenExpiresAt();
  return !!expiresAt && Date.now() >= expiresAt;
}

// 判断机构会话是否有效：token 存在且未过期
export function hasValidOrgSession() {
  const token = getOrgToken();
  return !!token && !isOrgTokenExpired();
}

// 清理机构登录态，仅影响机构侧 session，不影响主系统登录态
export function clearOrgSession() {
  uni.removeStorageSync(ORG_TOKEN_KEY);
  uni.removeStorageSync(ORG_TOKEN_EXPIRES_KEY);
  uni.removeStorageSync(ORG_USER_KEY);
  uni.removeStorageSync(REGISTERED);
}

// 清理 MOCA 主系统入口侧缓存，避免退出或切换入口后残留状态污染
export function clearMocaEntryCache() {
  uni.removeStorageSync('mocaEntryCheck');
  uni.removeStorageSync(MAIN_TOKEN_KEY);
}
